import { FileText, ListChecks } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const MODES = [
  { v: "complet", icon: ListChecks, title: "Devis complet", desc: "Paramètres techniques, détail du calcul, bonifications, volume CEE (MWhc), prix CEE et prime par opération." },
  { v: "simplifie", icon: FileText, title: "Devis simplifié", desc: "Fiches et opérations avec la prime par opération et la prime totale. Sans données techniques, sans volume ni prix CEE." },
];

export const QuoteModeDialog = ({ open, onOpenChange, onPick }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-lg" data-testid="quote-mode-dialog">
      <DialogHeader>
        <DialogTitle>Édition du devis</DialogTitle>
        <DialogDescription>Choisissez les informations à faire apparaître.</DialogDescription>
      </DialogHeader>
      <div className="grid gap-3">
        {MODES.map(({ v, icon: Icon, title, desc }) => (
          <button key={v} type="button" onClick={() => onPick(v)} data-testid={`quote-mode-${v}`}
            className="flex items-start gap-3 rounded-xl border border-border p-4 text-left transition-[border-color,background-color] hover:border-genis hover:bg-genis/5">
            <span className="h-9 w-9 shrink-0 grid place-items-center rounded-lg bg-genis/10 text-genis"><Icon className="h-4.5 w-4.5" /></span>
            <span>
              <span className="block font-semibold text-sm">{title}</span>
              <span className="block text-xs text-muted-foreground mt-0.5">{desc}</span>
            </span>
          </button>
        ))}
      </div>
    </DialogContent>
  </Dialog>
);
